<template>
  <div
    class="container"
    :style="{
      width: width + 'px',
      height: height + 'px',
      borderRadius: radius + 'px',
    }"
  >
    <img v-if="src" :src="src" @load="onImageLoad" />
  </div>
</template>
<script>
export default {
  name: "ImageClip",
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    radius: {
      type: Number,
      default: 0,
    },
    src: {
      type: String,
      default: "",
    },
  },
  methods: {
    onImageLoad($event) {
      let width = $event.target.naturalWidth;
      let height = $event.target.naturalHeight;
      if (width < this.width || height < this.height) {
        $event.target.style.width = "100%";
        $event.target.style.height = "100%";
        return;
      }
      let widthPercent = this.width / width;
      let heightPercent = this.height / height;
      let percent = widthPercent > heightPercent ? widthPercent : heightPercent;
      width = parseInt(width * percent);
      height = parseInt(height * percent);
      $event.target.style.width = width + "px";
      $event.target.style.height = height + "px";
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  overflow: hidden;
}
</style>
